// extracted by mini-css-extract-plugin
export default {"container":"_56xQDugBKsqDMBfcHtqd5Q","icon":"_65xs9D29710DivUsFLM0Mk","row":"_3weKogFavxXRSJvz9Fwm8F","label":"_52mSqUELFD2WYxN7ppTDIf","pricingInfo":"_34qg8A7NReTVPtzSGYMlvK"};